export default __webpack_public_path__ + "static/media/des_moines.ca7b464b.png";